import apiClient from '@/utils/apiClient'
import router from '@/router'

let base_errors = {}

export default {
  //region fetch
  async fetchAllUser({ commit }) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .get('api/user')
      .then(async (response) => {
        await commit('setUserList', response.data.users)
        await commit('setUserMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchAllUser', reason)
      })
  },
  async fetchUserByID({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .get(`api/user/${payload.id}`)
      .then(async (response) => {
        await commit('setUser', response.data.user)
        await commit('setUserMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchUserByID', reason)
      })
  },

  async fetchNewUser({ commit }) {
    commit('setUser', {})
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .get('api/model/new?model=user')
      .then(async (response) => {
        await commit('setUser', response.data.user)
        await commit('setUserMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchNewUser', reason)
      })
  },
  async fetchUserActivitiesByUserID({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .get(`api/user/fetch-activities/${payload.user_id}`)
      .then(async (response) => {
        await commit('setUserActivities', response.data.activities)
      })
      .catch(async (reason) => {
        await console.error(reason)
      })
  },
  //endregion

  //region store
  storeNewUser({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    return apiClient.post('api/user', payload.user).then(async (response) => {
      if (payload.user.customer_id) {
        await router.push({
          name: 'settings_edit_customer_route',
          params: { id: payload.user.customer_id }
        })
      } else {
        await router.push({ name: 'settings_list_user_route' })
      }
      return response.data
    })
  },
  //endregion

  //region update
  updateUser({ commit, dispatch }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    return apiClient
      .put(`api/user/${payload.id}`, payload.user)
      .then(async (response) => {
        dispatch('auth/refreshAuth', null, { root: true })
        commit('setUser', response.data.user)
        return response.data
      })
  },
  //endregion

  //region delete
  deleteUserById({ commit }, payload) {
    return apiClient
      .delete(`api/user-delete/${payload.id}`)
      .then(async (response) => {
        await commit('setUserList', response.data.users)
        await commit('setUserMetadata', response.data.metadata)
        return response.data
      })
  },
  //endregion

  //region undoDelete
  undoDeleteUserById({ commit }, payload) {
    return apiClient
      .get(`api/user/undo-delete/${payload.id}`)
      .then(async (response) => {
        await commit('setUserList', response.data.users)
        await commit('setUserMetadata', response.data.metadata)
        return response.data
      })
  }
  //endregion
}
